import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../utils/cn';
/**
 * Dekoratives Prefix/Suffix neben einem Feld (MUI-`InputAdornment`-Ersatz).
 * In einen `.sec-input-wrap.sec-input-wrap--{start|end}` legen.
 */
export const InputAdornment = forwardRef(function InputAdornment({ position, className, ...rest }, ref) {
    return (_jsx("span", { ref: ref, className: cn('sec-input-adornment', `sec-input-adornment--${position}`, className), ...rest }));
});
